import { Component, ViewEncapsulation} from '@angular/core';
import { Observable } from 'rxjs';

import { Breadcrumb } from './breadcrumb.model';
import { BreadcumbsService } from './breadcrumbs.service';
import { AsyncPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
  encapsulation: ViewEncapsulation.Emulated,
  selector: 'cosmos-breadcrumbs',
  imports: [
    AsyncPipe, TranslatePipe, MatIconModule, RouterModule
  ],
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.scss',]
})
export class BreadcrumbsComponent {

  breadcrumbs$: Observable<Breadcrumb[]>;

  constructor(private readonly breadCrumbService: BreadcumbsService) {
    this.breadcrumbs$ = this.breadCrumbService.breadcrumbs$;
   }

}
